import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import FooterOne from "../../components/FooterOne";
import SignUpPage from "../../components/my_account/SignUpPage";

const SignUp = () => {
    return (
        <>
            {/* Preloader */}
            <Preloader />

            {/* ScrollToTop */}
            <ScrollToTop smooth  />

            {/* ColorInit */}
            <ColorInit color={false} />

            {/* SignUpPage */}
            <SignUpPage />

            {/* FooterOne */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default SignUp;
